'use client';

import { useTranslations } from 'next-intl';
import styles from './SkipLink.module.css';

/**
 * Skip Link Component
 *
 * Provides keyboard users with a way to bypass navigation and skip directly to main content.
 * This is a WCAG 2.4.1 requirement for accessible websites.
 *
 * The link is visually hidden until focused, then appears prominently at the top of the viewport.
 */
export function SkipLink() {
  const t = useTranslations('accessibility');

  return (
    <a href="#main-content" className={styles.skipLink}>
      {t('skipToMain')}
    </a>
  );
}
